import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  UPDATE_PROFILE,
  GET_PROFILE,
  USERS_BALANCE,
  M_GET,
  M_PUT,
  M_POST,
} from '@/utils/api';

import serviceUtils from '@/services/utils';
import jwt_decode from 'jwt-decode';

import Vue from 'vue';

@Module({ name: 'profile' })
export default class Profile extends VuexModule {
  @Action
  async UpdateProfile(user) {
    return Vue.axios({
      url: BASE_URL + UPDATE_PROFILE,
      data: user,
      method: M_PUT,
    })
      .then(({ data }) => {
        const { status } = data;
        return status;
      })
      .catch((err) => err);
  }

  @Action
  async FetchProfile() {
    const getPersist = await serviceUtils.getUserPersistent();
    return Vue.axios({
      url: BASE_URL + GET_PROFILE,
      method: M_GET,
    })
      .then(({ data }) => {
        const decodeToken: any = data ? jwt_decode(data.data) : {};
        const { profile, status } = decodeToken;
        const userPersist = { ...getPersist };
        userPersist.user.profile = profile;
        Vue.prototype.$session.set('ambgames-user-authenticate', JSON.stringify(userPersist));
        this.context.commit('setProfile', userPersist.user);
        return status;
      })
      .catch((err) => err);
  }

  @Action
  async GetBalance() {
    const getPersist = await serviceUtils.getUserPersistent();
    return Vue.axios({
      url: BASE_URL + USERS_BALANCE,
      method: M_POST,
    }).then(({ data }) => {
      const { data: { wallet }, status } = data;
      const userPersist = { ...getPersist };
      userPersist.user.wallet.balance = wallet;
      Vue.prototype.$session.set('ambgames-user-authenticate', JSON.stringify(userPersist));
      this.context.commit('setProfile', userPersist.user);
      return status;
    })
      .catch((err) => err);
  }
}
